import { createSelector } from "@reduxjs/toolkit";

import { dataSelector } from "./helpers";
import { IDataKeys } from "shared/types";
import { buildData } from "Bands/state";
import { IBandUser } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";

export const bandUsersSelector = createSelector(
  dataSelector,
  (data) => (buildData(data as any, IDataKeys.bandUser) || []) as IBandUser[]
);

export const myBandUsersSelector = createSelector(
  dataSelector,
  (data) => (buildData(data as any, IDataKeys.myBandUsers) || []) as IBandUser[]
);

const dataBandUsersSelector = createSelector(
  dataSelector,
  (data) => data.bandUser
);

export const bandUserSelectorCreator = (id: string) =>
  createSelector(dataBandUsersSelector, (users) => {
    const user = users?.[API_ENDPOINTS.BAND_USER(id)];
    if (user) {
      return buildSingleItem(user) as IBandUser;
    }
    return null;
  });
